import React from "react";
import { auth } from "../config/firebase";
import { ROUND_STATUS, updatePlayerRoundSolveStatus } from "./utils/MatchUtils";
import Scramble from "./Scramble";
import { useSolve } from "../hooks/useSolve";
import BasicTable from "./BasicTable";
import { Alg } from "cubing/alg";
import { BluetoothCubeComponent } from "./BluetoothComponent";

export interface MatchPlayerProps {
  matchId: string;
  playerId: string;
  roundNumber: number,
  solveNumber: number,
  streamid: string
}

const MatchPlayer: React.FC<MatchPlayerProps> = ({ matchId, playerId, streamid, roundNumber, solveNumber }) => {
  const { solve, loadingSolve, errorSolve } = useSolve(
      matchId,
      playerId,
      roundNumber,
      solveNumber
    ); 
    
  return (
    <>
    {!loadingSolve && auth.currentUser?.uid === playerId  && solve!=null && solve.status === ROUND_STATUS.ReadyToSolve && <BluetoothCubeComponent
      streamid={streamid}
      alg={new Alg(solve.scramble)}
      onComplete={(time=>{
        updatePlayerRoundSolveStatus(matchId, playerId, roundNumber, solveNumber, time, ROUND_STATUS.Solved )
      })}
    />}

    {!loadingSolve && auth.currentUser?.uid === playerId  && solve!=null && solve.status === ROUND_STATUS.Revealed && <Scramble 
      matchId={matchId}
      roundNumber={roundNumber}
      solveNumber={solveNumber}
      onComplete={()=>{
        updatePlayerRoundSolveStatus(matchId, playerId, roundNumber, solveNumber, null, ROUND_STATUS.Scrambled )
      }}/>}

    {/* {!loadingSolve && auth.currentUser?.uid === playerId  && solve!=null && solve.status === ROUND_STATUS.ScrambleVerified && <Countdown 
      matchId={matchId}
      roundNumber={roundNumber}
      solveNumber={solveNumber}
      onComplete={()=>{
          updatePlayerRoundSolveStatus(matchId, playerId, roundNumber, solveNumber, null, ROUND_STATUS.ReadyToSolve )
      }}/>} */}

    {!loadingSolve && auth.currentUser?.uid === playerId  && <BasicTable
        roundNumber={roundNumber}
        solveNumber={solveNumber}
        rounds={[]}
        solveResults={solve === null ? [] : [solve]} 
        updateStatus={function (roundNumber: number, solveNumber: number, scramble: string, time: number | null, status: ROUND_STATUS): void {
          throw new Error("Function not implemented.");
        } }    />}
    {/* {!loading && solve!=null && solve.status === ROUND_STATUS.ReadyToSolve && <Countdown 
      matchId={matchId}
      roundNumber={roundNumber}
      solveNumber={solveNumber}
      onComplete={()=>{
          updatePlayerRoundSolveStatus(matchId, playerId, roundNumber, solveNumber, null, ROUND_STATUS.Solving )
      }}/>} */}

  </>
  )
};

export default MatchPlayer;
